<template>
	<div>
		<div class="button-group has-text-centered mb40">
			<button v-for="(val, key , index) in option.getFilterData" class="button btn-transparent hvr-warning hvr-dashed is-size-6 has-text-primary has-text-weight-bold mr5 ml5 mb20" :class="[key===filterOption ? 'is-checked' : '']"  @click="filter(key)">
				{{t(key)}}
			</button>
		</div>
		<isotope ref="cpt" class="columns is-multiline" id="root_isotope1" :item-selector="'element-item'" :list="list" :options='option' @filter="filterOption=arguments[0]" >
			<div v-for="element,index in list" :class='[element.category]'  class="column is-3 hvr-grow p5 card-with-hover-project" :key="index">
				<div class="radius-lg overflow-hidden position-relative card-with-overlay card-grey">
					<a rel="noreferrer" href="#" class="radius-lg-img is-overlay-hideen is-block position-relative ">
						<figure class="image-cover">
							<img :src="element.image"  @load="changeLayout(layout)">
						</figure>
						<div class="is-overlay">
							<p class="has-background-warning has-text-white overlay-title has-text-weight-bold">
								{{element.name}}
							</p>
						</div>
					</a>
				</div>
			</div>
		</isotope>
	</div>
</template>

<script>
	import isotope from 'vueisotope';
	import LazyLoad from '../GeneralComponents/LazyLoad';
	import trans from "./translation/gallery.json";
	var count = 0;
	export default {
		name: 'Projects',
		components:{
			isotope,
			LazyLoad
		},
		props: {
			sitelocale: {
				type: String,
				required: true
			},
		},
		data() {
			return {
				layout: "masonry",
				list: [{
					name: " تجميعة تصميمات سوشيال ميديا لشهر مايو  ",
					date: "22/4/2019",
					views: 80,
					link: "200.59",
					image: "/front/img/img1.png",
					category: "conventions galleries"

				}, {
					name: "Tellurium",
					date: "22/4/2019",
					views: 52,
					link: "127.6",
					image: "/front/img/img2.png",
					category: "galleries conventions"
				}, {
					name: "Bismuth",
					date: "22/4/2019",
					views: 83,
					link: "208.980",
					image: "/front/img/img3.png",
					category: "galleries"
				}, {
					name: "Lead",
					date: "22/4/2019",
					views: 82,
					link: "207.2",
					image: "/front/img/img4.png",
					category: "galleries"
				}, {
					name: "Gold",
					date: "22/4/2019",
					views: 79,
					link: "196.967",
					image: "/front/img/img5.png",
					category: "conventions"
				}, {
					name: "Potassium",
					date: "22/4/2019",
					views: 19,
					link: "39.0983",
					image: "/front/img/img5.png",
					category: "events"
				}, {
					name: "Sodium",
					date: "22/4/2019",
					views: 11,
					link: "22.99",
					image: "/front/img/img1.png",
					category: "galleries"
				}, {
					name: "Cadmium",
					date: "22/4/2019",
					views: 48,
					link: "112.411",
					image: "https://via.placeholder.com/318x220",
					category: "conventions"
				}, {
					name: "Calcium",
					date: "22/4/2019",
					views: 20,
					link: "40.078",
					image: "https://via.placeholder.com/318x220",
					category: "events"
				}, {
					name: "Rhenium",
					date: "22/4/2019",
					views: 75,
					link: "186.207",
					image: "https://via.placeholder.com/318x220",
					category: "conventions"
				}, {
					name: "Ytterbium",
					date: "22/4/2019",
					views: 55,
					link: "186.207",
					image: "https://via.placeholder.com/318x220",
					category: "events galleries"
				}, ],
				currentLayout: 'masonry',
				selected: null,
				sortOption: "original-order",
				filterOption: "all",
				option: {
					itemSelector: ".element-item",
					isOriginLeft: this.sitelocale == "ar" ? false : true,
					getFilterData: {
						"all": function(name) {
							return true;
						},
						"conventions": function(el) {
							if(el.category.includes("conventions")){
								return el.category
							}
						},
						"galleries": function(el) {
							if(el.category.includes("galleries")){
								return el.category
							}
						},
						"events": function(el) {
							if(el.category.includes("events")){
								return el.category
							}
						},
					},
				}
			}
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
			let mainElement = this.$refs.cpt;
			document.addEventListener("DOMContentLoaded", () => {
				setTimeout(function(){mainElement.layout(this.layout); }, 1500);
			});

		},
		locales: trans,
		methods: {
			sort: function(key) {
				this.$refs.cpt.sort(key);
			},
			filter: function(key) {
				this.$refs.cpt.filter(key);
			},
			changeLayout: function(key) {
				this.$refs.cpt.layout(key);
			}
		},
	};
</script>

<style lang="scss">

</style>


